export const AsynLoader = props => {
  return null;
};
